<template>
	<div class="pageBanner" >
		<div class="box">
			{{ title }}
		</div>
	</div>
</template>
<script>
export default {
	name:'pageBanner',
	props:['title'],
	data(){
		return{

		}
	},
	created() {
	},
	methods: {
		
	},
}
</script>
<style scoped>
.pageBanner {
	width: 100%;
	/* position: fixed; */
	height: 500px;
	overflow: hidden;
	margin-top: 110px;
	/* margin: auto; */
	/* top: 100px; */
	background: url("~@/assets/images/banners.jpeg") top center no-repeat;
	background-size: cover;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
}

.pageBanner .box {
  display: inline-block;
  /* margin-top: 150px; */
  font-size: 40px;
  color: #ffffff;
}

.pageBanner .box:after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background: white;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/banner/index.vue